import { speak } from "@wordpress/a11y";
import classNames from "classnames";
import React, { useEffect } from "react";
import { defineMessages, injectIntl, intlShape } from "react-intl";

import useSubscriptionSummary from "../../hooks/useSubscriptionSummary";
import AiBrandInsightsCard from "./AiBrandInsightsCard";
import PluginUpsell from "./PluginUpsell";
import SitesOverviewCard from "./SitesOverviewCard";
import SupportCard from "./SupportCard";
import WhatsNewCard from "./WhatsNewCard";
import * as styles from "./HomePageStyles.module.scss";

const messages = defineMessages( {
	homePageLoaded: {
		id: "home.page.loaded",
		defaultMessage: "Home page loaded",
	},
} );

const cards = [
	{
		id: "sites-card",
		className: "SitesOverviewCard",
		component: <SitesOverviewCard />,
	},
	{
		id: "ai-brand-insights-card",
		className: "AiBrandInsightsCard",
		component: <AiBrandInsightsCard />,
	},
	{
		id: "plugin-upsell-card",
		className: "UpsellCard",
		component: <PluginUpsell />,
	},
	{
		id: "support-card",
		className: "SupportCard",
		component: <SupportCard />,
	},
	{
		id: "whats-new-card",
		className: "WhatsNewCard",
		component: <WhatsNewCard />,
	},
];

/**
 * Returns the rendered HomePage component.
 *
 * @param {Object} props The props to use.
 *
 * @returns {ReactElement} The rendered home page.
 */
const HomePage = props => {
	const { summary } = useSubscriptionSummary();

	/**
	 * Speaks a message when the component mounted.
	 *
	 * @returns {void}
	 */
	useEffect( () => {
		// Announce navigation to assistive technologies.
		const message = props.intl.formatMessage( messages.homePageLoaded );
		speak( message );
	}, [] );

	/**
	 * Wraps the inner card content components in a ShadowDiv and a FullHeightCard.
	 *
	 * @param {Object[]} cardsArray An array of cards with id, className, and the inner card component.
	 *
	 * @returns {ReactElement[]} Returns an array of React elements.
	 */
	const createCards = ( cardsArray ) => {
		// A customer whose access all comes from a third party has no sites to manage here and nothing
		// to upsell. While the summary loads this is false, which is what the page assumed before it
		// had the subscription data either.
		if ( summary.isOnlyProvisioner ) {
			cardsArray = cardsArray.filter( card => ! [ "sites-card", "plugin-upsell-card" ].includes( card.id ) );
		}

		return cardsArray.map( card => {
			return <div id={ card.id } key={ card.id } className={ classNames( styles.cardWrapper, card.className ) }>
				{ card.component }
			</div>;
		} );
	};

	return (
		<div className={ styles.homeGridContainer }>
			<div className={ styles.homeGrid }>
				{ createCards( cards ) }
			</div>
		</div>
	);
};

HomePage.propTypes = {
	intl: intlShape.isRequired,
};

export default injectIntl( HomePage );


